import {
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import "altcha";
import { useTheme } from "@mui/material";

const Altcha = forwardRef((_, ref) => {
  const theme = useTheme();
  const widgetRef = useRef(null);
  const [value, setValue] = useState(null);

  useImperativeHandle(
    ref,
    () => ({
      get value() {
        return value;
      },
    }),
    [value],
  );

  useEffect(() => {
    const el = widgetRef.current;
    if (!el) return;

    const handler = (ev) => {
      if (ev.detail?.payload) {
        setValue(ev.detail.payload);
      }
    };

    el.addEventListener("statechange", handler);
    return () => el.removeEventListener("statechange", handler);
  }, []);

  return (
    <altcha-widget
      ref={widgetRef}
      id="altcha"
      name="altcha"
      challengeurl="https://altcha.byerline.me/challenge?serviceName=adventure-playhouses"
      style={{
        "--altcha-border-width": "0",
        "--altcha-max-width": "none",
        "--altcha-color-border": "transparent",
        "--altcha-color-base": "transparent",
        "--altcha-font-family": '"Futura", "Helvetica", "Arial", sans-serif',
        display: "block",
        margin: "1rem 0",
        backgroundColor: theme.palette.custom.white,
        color: theme.palette.text.primary,
        borderRadius: "8px",
        fontWeight: "bold",
        fontFamily: '"Futura", "Helvetica", "Arial", sans-serif',
        textTransform: "lowercase",
        marginTop: "0px",
      }}
    />
  );
});

export default Altcha;
